import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { getSummaryStats } from "../../Api/FleetOverviewApi";
import TotalVehiclesCard from "./TotalVehiclesCard";
import LiveVehicleStatusCard from "./LiveVehicleStatusCard";
import FleetMetricsCard from "./FleetMetricsCard";

/**
 * Custom platform StatsSection.
 *
 * Renders the top stat row: Total Vehicles, Live Status, and Fleet Metrics.
 * Which widgets appear is driven by the `widgets` array from
 * customDashboards[activeKey].overview.widgets.
 *
 * Layout mirrors the Coulomb version:
 *   Left 75%: [TotalVehicles 30%] [LiveVehicleStatus 70%]
 *   Right 25%: FleetMetrics
 */
const StatsSection = ({ globalFilters, widgets = [], metricsConfig = {} }) => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);

  const showTotal        = widgets.includes("totalVehicles");
  const showLiveStatus   = widgets.includes("vehicleLiveStatus");
  const showFleetMetrics = widgets.includes("fleetMetrics");

  useEffect(() => {
    if (Object.keys(globalFilters).length === 0) return;

    const fetchStats = async () => {
      setLoading(true);
      const res = await getSummaryStats(globalFilters);
      setStats(res?.response?.data?.stats || {});
      setLoading(false);
    };

    fetchStats();
  }, [globalFilters]);

  const hasLeftSection = showTotal || showLiveStatus;

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      {hasLeftSection && (
        <Box sx={{ width: showFleetMetrics ? "75%" : "100%" }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            {showTotal && (
              <Box sx={{ width: showLiveStatus ? "30%" : "100%", display: "flex" }}>
                <TotalVehiclesCard stats={stats} loading={loading} />
              </Box>
            )}
            {showLiveStatus && (
              <Box sx={{ width: showTotal ? "70%" : "100%", display: "flex" }}>
                <LiveVehicleStatusCard stats={stats} globalFilters={globalFilters} loading={loading} />
              </Box>
            )}
          </Box>
        </Box>
      )}
      {showFleetMetrics && (
        <Box sx={{ width: hasLeftSection ? "25%" : "100%", display: "flex" }}>
          <FleetMetricsCard stats={stats} loading={loading} metricsConfig={metricsConfig} />
        </Box>
      )}
    </Box>
  );
};

export default StatsSection;
